import type { UserSettings, BookingCategories } from '~common/storage/users'
import type { PluginId } from './config'
import { getDatevPluginConfig } from './config'

export function isPluginEnabled(
    pluginId: PluginId,
    settings: UserSettings | null | undefined,
): boolean {
    if (!settings?.plugins) return false
    return settings.plugins[pluginId]?.enabled ?? false
}

export function getPluginConfig(
    pluginId: PluginId,
    settings: UserSettings | null | undefined,
): NonNullable<UserSettings['plugins']>[PluginId] | undefined {
    return settings?.plugins?.[pluginId]
}

export function getBookingCategoriesFromPlugin(
    settings: UserSettings | null | undefined,
): BookingCategories | undefined {
    const datevPluginConfig = getDatevPluginConfig(settings)
    return datevPluginConfig?.config
}
